import React, { useEffect, useState } from 'react';
import './BakimFiyatTopluAtaModal.css';

const BakimFiyatTopluAtaModal = ({ open, selectedCount, saving, onClose, onSubmit }) => {
  const [bakimFiyati, setBakimFiyati] = useState('');
  const [fabrikaPayi, setFabrikaPayi] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setBakimFiyati('');
      setFabrikaPayi('');
      setError('');
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {};
    const bfTrim = bakimFiyati.trim();
    const fpTrim = fabrikaPayi.trim();
    if (bfTrim === '' && fpTrim === '') {
      setError('En az bir fiyat alanı doldurulmalıdır');
      return;
    }
    if (bfTrim !== '') {
      const n = Number(bfTrim);
      if (!Number.isFinite(n) || n < 0) {
        setError('Bakım fiyatı 0 veya daha büyük olmalıdır');
        return;
      }
      payload.bakimFiyati = n;
    }
    if (fpTrim !== '') {
      const n = Number(fpTrim);
      if (!Number.isFinite(n) || n < 0) {
        setError('Fabrika payı 0 veya daha büyük olmalıdır');
        return;
      }
      payload.fabrikaPayi = n;
    }
    setError('');
    onSubmit(payload);
  };

  return (
    <div className="modal-overlay bakim-toplu-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal-content bakim-toplu-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="bakim-toplu-modal-title"
      >
        <div className="modal-header">
          <h2 id="bakim-toplu-modal-title">Seçilenlere fiyat ata</h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" />
          </button>
        </div>
        <form className="bakim-toplu-modal__form" onSubmit={handleSubmit}>
          <p className="bakim-toplu-modal__hint">
            {selectedCount} ürün seçildi. Doldurduğunuz alanlar seçili ürünlere uygulanır; boş bıraktığınız alan değiştirilmez.
          </p>
          {error ? <p className="bakim-toplu-modal__error">{error}</p> : null}
          <label className="bakim-toplu-modal__field">
            <span>Bakım fiyatı (₺)</span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={bakimFiyati}
              onChange={(e) => setBakimFiyati(e.target.value)}
              placeholder="Opsiyonel"
              disabled={saving}
            />
          </label>
          <label className="bakim-toplu-modal__field">
            <span>Fabrika payı (₺)</span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={fabrikaPayi}
              onChange={(e) => setFabrikaPayi(e.target.value)}
              placeholder="Opsiyonel"
              disabled={saving}
            />
          </label>
          <div className="bakim-toplu-modal__actions">
            <button type="button" className="secondary-btn" onClick={onClose} disabled={saving}>
              İptal
            </button>
            <button type="submit" className="primary-btn" disabled={saving}>
              {saving ? 'Kaydediliyor…' : 'Uygula'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BakimFiyatTopluAtaModal;
